import { computed as g, onUnmounted as S, inject as $ } from "vue";
import { modalApiInjectionKey as j } from "./highrise1163.mjs";
import { throwError as B } from "./highrise1064.mjs";
import { on as u, off as G } from "./highrise632.mjs";
function H() {
  const t = $(j, null);
  return t === null && B("use-modal", "No outer <n-modal-provider /> founded."), t;
}
const A = "n-draggable";
function I(t, E) {
  let i;
  const M = g(() => t.value !== !1), h = g(() => M.value ? A : ""), R = g(() => {
    const e = t.value;
    return e === !0 || e === !1 ? !0 : e ? e.bounds !== "none" : !0;
  });
  function C(e) {
    const s = e.querySelector(`.${A}`);
    if (!s || !h.value)
      return;
    let d = 0, f = 0, c = 0, a = 0, y = 0, X = 0, l;
    function Y(r) {
      r.preventDefault(), l = r;
      const {
        x: m,
        y: p,
        right: n,
        bottom: o
      } = e.getBoundingClientRect();
      f = m, a = p, d = window.innerWidth - n, c = window.innerHeight - o;
      const {
        left: w,
        top: v
      } = e.style;
      y = +v.slice(0, -2), X = +w.slice(0, -2);
    }
    function b(r) {
      if (!l) return;
      const {
        clientX: m,
        clientY: p
      } = l;
      let n = r.clientX - m, o = r.clientY - p;
      R.value && (n > d ? n = d : -n > f && (n = -f), o > c ? o = c : -o > a && (o = -a));
      const w = n + X, v = o + y;
      e.style.top = `${v}px`, e.style.left = `${w}px`;
    }
    function D() {
      l = void 0, E.onEnd(e);
    }
    u("mousedown", s, Y), u("mousemove", window, b), u("mouseup", window, D), i = () => {
      G("mousedown", s, Y), u("mousemove", window, b), u("mouseup", window, D);
    };
  }
  function x() {
    i && (i(), i = void 0);
  }
  return S(x), {
    stopDrag: x,
    startDrag: C,
    draggableRef: M,
    draggableClassRef: h
  };
}
export {
  A as DRAGGABLE_CLASS,
  I as useDragModal,
  H as useModal
};
